import { CardImage, Pricing } from '.';
import { MouseEvent, useRef } from 'react';
import classNames from 'classnames';
import { ComponentType } from '@/types/cml-api';
import { elementTrackingId } from '@/app/(home-page)/_components/contants';
import { useCustomAttributes } from '@/app/(home-page)/_components/utils/use-custom-attr';
import { DirectAddToCart } from './add-to-cart';
import { PDPCardProps } from './types';
import { AppNextLink } from '../app-next-link';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { getProductURL } from '../navigation/utils/url-helpers';
import { handleShowPageLoading } from '../page-loading/utils/show-loading';
export const PDPCard = ({
  pricingProps,
  brand,
  name,
  slug,
  image,
  isLazy,
  showDirectAddToCart,
  type,
  atpId,
  itemProposalId,
  isSalable,
  className = '',
  count,
  index,
  preventNavigation
}: PDPCardProps) => {
  const {
    isMobile
  } = useMobileDetect();
  const linkRef = useRef<HTMLAnchorElement>(null);
  useCustomAttributes(linkRef, {
    elementType: ComponentType.ProductList,
    elementIndex: index || '0',
    elementTrackingId: elementTrackingId,
    elementName: `${ComponentType.ProductList}-${count}`
  });
  const handleClick = (event: MouseEvent) => {
    if (showDirectAddToCart || preventNavigation) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (!event.ctrlKey) handleShowPageLoading();
  };

  // eslint-disable-next-line no-nested-ternary
  const imageSize = type === 'horizontal' ? isMobile ? 112 : 128 : isMobile ? 120 : 140;
  return <AppNextLink ref={linkRef} prefetch={false} href={getProductURL(slug || '')} className={classNames('flex h-full w-full gap-1 rounded border border-border-gray-light bg-surface-solid-0 p-2 shadow-sm', {
    'flex-col': type === 'vertical',
    'cursor-default': preventNavigation
  }, className)} onClick={handleClick} data-sentry-element="AppNextLink" data-sentry-component="PDPCard" data-sentry-source-file="pdp-card.tsx">
            <CardImage alt={`${name} ${brand}`} image={image} srcSet={{
      desktop: 130,
      mobile: 175
    }} isLazy={isLazy} imageClassName={classNames('aspect-square', {
      'lg:w-32 lg:h-32 w-28 h-28': type === 'horizontal',
      'w-30 lg:w-35 h-30 lg:h-35': type === 'vertical'
    })} parentClassName='h-fit shrink-0' width={imageSize} height={imageSize} data-sentry-element="CardImage" data-sentry-source-file="pdp-card.tsx" />

            <div className={classNames('flex grow flex-col justify-between', {
      'gap-3': type === 'vertical',
      'gap-2 lg:gap-3': type === 'horizontal'
    })}>
                <div className='flex flex-col gap-1 text-caption-12 lg:text-body-14'>
                    <span className='text-text-darkGray'>{brand}</span>

                    <h3 className='line-clamp-2 text-text-black'>{name}</h3>
                </div>

                <div className='flex justify-between'>
                    {showDirectAddToCart && type === 'vertical' && atpId && itemProposalId && <DirectAddToCart atpId={atpId} itemProposalId={itemProposalId} size='responsive' index={index} />}

                    {isSalable ? <Pricing {...pricingProps} className='mr-auto' /> : <span className='mr-auto text-caption-12 font-medium lg:px-5 lg:text-body-14'>تمام شد</span>}
                </div>
            </div>
        </AppNextLink>;
};